import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SurveyContentCardFragmentDoc } from '../../../../../../content/modules/survey/fragments/generated/SurveyContentCard';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SurveyCardContentQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  isEmbed: Types.Scalars['Boolean']['input'];
  languageType?: Types.InputMaybe<Types.LanguageEnum>;
}>;


export type SurveyCardContentQuery = { content?: { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null } | {} | null };


export const SurveyCardContentDocument = /*#__PURE__*/ gql`
    query surveyCardContent($id: String!, $isEmbed: Boolean!, $languageType: LanguageEnum) {
  content(filters: {id: $id, isEmbed: $isEmbed, languageType: $languageType}) {
    ... on SurveyContentType {
      ...SurveyContentCard
    }
  }
}
    ${SurveyContentCardFragmentDoc}
${EntityMediaFragmentDoc}`;

export function useSurveyCardContentQuery(options: Omit<Urql.UseQueryArgs<SurveyCardContentQueryVariables>, 'query'>) {
  return Urql.useQuery<SurveyCardContentQuery, SurveyCardContentQueryVariables>({ query: SurveyCardContentDocument, ...options });
};